import React, { useState } from 'react'
import classNames from 'classnames'

// import { Label } from './input'
import styles from '../component-styles/request-branded-domain-modal.module.scss'
import Modal, { ModalHead, ModalBody, ModalFooter } from './modal'
import ConfirmationButtons from './confirmation-buttons'
import Heading from './heading'
import { logAction } from '../api-client/analytics-client'
import Input, { Label } from './input'
import ToolTip from './tooltip'
import { requestFeature } from '../api-client/support-client'

interface RequestBrandedDomainModalProps {
  onHideModal: () => void
}
export default function RequestBrandedDomainModal({
  onHideModal,
}: RequestBrandedDomainModalProps): React.ReactElement | null {
  const [domain, setDomain] = useState('')
  const [showThankYou, setShowThankYou] = useState(false)

  return (
    <Modal
      active
      toggleActive={() => {
        onHideModal()
      }}
      type="white"
      superNarrow
    >
      <ModalHead>
        <Heading type={3} align="left">
          Request branded short link
        </Heading>
      </ModalHead>
      {!showThankYou && (
        <ModalBody>
          <p>
            Make your links trustworthy by upgrading to a branded short link
            domain.
          </p>
          <p>
            This gives you control over the characters after the domain.
            Allowing you to create memorable links for offline media.
          </p>
          <p className={styles.example}>
            Example: <span className={styles.boxed}>your.company/offer1</span>
          </p>
          <p>
            You can give us access to your domain or we can buy one on your
            behalf. Put your preferred domain below and we will get in contact.
          </p>
          <Label
            modalHeading
            id="domain"
            optional="(optional)"
            className={styles.modalLabel}
          >
            <span>Preferred domain</span>
            <ToolTip
              className={styles.tooltip}
              message="Enter the name of a short domain you want to integrate with Uplifter."
            />
          </Label>
          <Input
            className={styles.domainInput}
            required
            name="domain"
            onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
              const { value: val } = e.target as HTMLInputElement
              setDomain(val)
            }}
            value={domain}
          />
        </ModalBody>
      )}
      {showThankYou && (
        <ModalBody>
          <p>
            Thank you for contacting us and requesting custom domain
            integration. We will be in touch soon!
          </p>
        </ModalBody>
      )}
      <ModalFooter>
        <ConfirmationButtons
          type="simple"
          className={classNames(styles.confirmationButtons, {
            [styles.showThankYou]: showThankYou,
          })}
          onYes={async () => {
            if (!showThankYou) {
              setShowThankYou(true)
              const message = `Request custom domain: ${domain}`
              await requestFeature({
                page: 'track/create-campaign-codes',
                message,
              })
              const actionData = {
                action: 'request-custom-domain',
                longDescription: message,
                websiteSection: 'track',
              }
              await logAction(actionData)
            } else {
              onHideModal()
            }
          }}
          onNo={
            showThankYou
              ? undefined
              : (): void => {
                  onHideModal()
                }
          }
          yesLabel={showThankYou ? 'Finished' : 'Send request'}
          noLabel="Cancel"
        />
      </ModalFooter>
    </Modal>
  )
}
